import React from 'react';
import './HighlightBlock.module.scss';

type Props = {
  item: any;
};

export default function HighlightBlock({ item }: Props) {
  return (
    <div styleName="HighlightBlock ">
      <h4>
        HighlightBlock <br />
        dfafd
      </h4>
    </div>
  );
}
